import request from '@/http/http'
const PREFIX = 'api/saas';
export function getTenants(query) {
    return request({
        url: PREFIX + '/tenants',
        params:query
    })
}
export function getTenantInfo(id) {
    return request({
        url: `${PREFIX}/tenants/${id}`,
    })
}
export function deleteTenant(id) {
    return request({
        url: `${PREFIX}/tenants/${id}`,
        method: 'delete',
    })
}
export function creatTenant(data) {
    return request({
        url: "api/deer/tenants",
        method: 'post',
        data
    })
}
export function updateTenant(id,data) {
    return request({
        url: `${PREFIX}/tenants/${id}`,
        method: 'put',
        data
    })
}